import { select } from "@wordpress/data";
import { STORE_NAME } from "../store";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

export const Breadcrumbs = () => {
	const chapters = select( STORE_NAME ).getChapters();
	const currentChapter = chapters.find(chapter => chapter.current);
	const verses = select( STORE_NAME ).getVerses();
	const currentVerse = verses.find(verse => verse.current);
	const bookData = select( STORE_NAME ).getBookData();
	const bookTitle = bookData.title;
	const bookPermalink = bookData.permalink;

	if( verses.length < 2 && currentVerse ) {
		window.location.href = currentChapter.permalink;
	}

	const verseNum = currentVerse ? currentVerse.title.split(".")[1] : null;
	const verseText = currentVerse ? `${verseNum.includes("-") ? "פסוקים" : "פסוק"} ${verseNum}` : null;
	
	return <div>
		<a href="/">דף הבית</a>
		<KeyboardDoubleArrowLeftIcon sx={{ fontSize: 18 }} className="mx-1" />
		<a href={bookPermalink}>{bookTitle}</a>
		{ (currentChapter || currentVerse) && <>
			<KeyboardDoubleArrowLeftIcon sx={{ fontSize: 18 }}  className="mx-1" />
			<a href={currentChapter.permalink}>{currentChapter.title}</a>
		</> }
		{ currentVerse && <>
			<KeyboardDoubleArrowLeftIcon sx={{ fontSize: 18 }} className="mx-1" />
			<a href={currentVerse.permalink}>{verseText}</a>
		</> }
	</div>;
}